export const community = {
  avatar: 'Profielfoto van {{name}}',
  breadcrumb: {
    overview: 'Netwerk',
  },
  detail: {
    disabled: 'Het profiel van deze Shelteraar staat niet meer openbaar.',
    error: {
      title: 'Fout bij het laden van het profiel.',
    },
  },
  enableCommunityProfileDialog: {
    actions: {
      goToSettings: 'Profiel openbaar zetten',
    },
    description:
      'Stel jij graag een vraag in het forum, wil jij andere freelancers zoeken en vinden, heb je een opdracht gezien die je interesseert of plaats je zelf graag een opdracht? <br/>Dan is een openbaar Community-profiel the way to go. Via je profiel pas je dat snel en makkelijk aan.',
    title: 'Neem deel aan onze Community',
  },
  header: {
    preview: 'Je profiel bekijken',
    title: 'Netwerk',
  },
  infoCards: {
    activity: {
      action: 'Filter op je activiteiten',
      description_one: '{{count}} freelancer deelt je activiteiten',
      description_other: '{{count}} freelancers delen je activiteiten',
      description_zero: 'Nog geen freelancers met dezelfde activiteiten',
      title: 'Freelancers met dezelfde activiteiten',
    },
    error: 'Kon niet worden geladen',
    profile: {
      action: 'Profiel aanvullen',
      description: 'Vul je profiel zo goed mogelijk aan en vergroot zo je netwerk.',
      title: 'Zorg dat anderen je vinden',
    },
    region: {
      action: 'Filter op je regio',
      description_one: '{{count}} freelancer is actief in je regio',
      description_other: '{{count}} freelancers zijn actief in je regio',
      description_zero: 'Nog geen freelancers in je regio',
      title: 'Freelancers in je regio',
    },
  },
  overview: {
    errorLoading: 'Er ging iets mis bij het ophalen van het netwerk.',
    filters: {
      activity: {
        label: 'Activiteiten',
      },
      name: {
        placeholder: 'Zoek op naam',
      },
      openToWork: {
        text: 'Beschikbaar voor opdrachten',
      },
      region: {
        label: 'Regio',
      },
    },
    loading: 'Gegevens aan het laden…',
    locked: {
      button: 'Zet je profiel openbaar',
      description: 'Zet je profiel openbaar om deel te worden van de Community',
      success: 'Je profiel is nu openbaar. Welkom bij de Craft Community!',
    },
    resultCount_one: '{{count}} resultaat',
    resultCount_other: '{{count}} resultaten',
    resultCount_zero: 'Geen match gevonden op basis van je zoekcriteria',
  },
  profileCard: {
    activeInRegion: 'Actief in {{regions}}',
    footer: {
      behance: 'Behance',
      facebook: 'Facebook',
      instagram: 'Instagram',
      linkedIn: 'LinkedIn',
      mail: 'E-mail',
      website: 'Website',
    },
    openDialog: 'Profiel van {{name}} bekijken',
    openToWork: 'Beschikbaar',
  },
  regions: {
    Abroad: 'Buitenland',
    Antwerp: 'Antwerpen',
    Brussels: 'Brussel',
    EastFlanders: 'Oost-Vlaanderen',
    FlemishBrabant: 'Vlaams-Brabant',
    Hainaut: 'Henegouwen',
    Liege: 'Luik',
    Limburg: 'Limburg',
    Luxembourg: 'Luxemburg',
    Namur: 'Namen',
    WalloonBrabant: 'Waals-Brabant',
    WestFlanders: 'West-Vlaanderen',
  },
};
